<span [ngClass]="wrapClass">
  <span class="name">{{entity | fullName }}</span>
  <span class="pronouns">{{pronouns}}</span>
</span>
